package one.devsbox.shared.files

import one.devsbox.commons.EType

enum class ResourceType(override val mask: Int) : EType {
    IMAGE(2),
    VIDEO(4),
    PDF(8);

    companion object : EType.Finder<ResourceType>(entries)
}

val ResourceType.Companion.ALL: Int get() = ResourceType.entries.sumOf { it.mask }